import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  // Track collapsed state instead of open/close visibility
  private collapsedSubject = new BehaviorSubject<boolean>(false); // false = expanded
  collapsed$ = this.collapsedSubject.asObservable();

  toggleSidebar(): void {
    this.collapsedSubject.next(!this.collapsedSubject.value);
  }

  setSidebarState(collapsed: boolean): void {
    this.collapsedSubject.next(collapsed);
  }

  getSidebarState(): boolean {
    return this.collapsedSubject.value;
  }
}
